var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "#1E2022",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trees"
  }, /*#__PURE__*/React.createElement("path", {
    id: "trees_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0484 23.1179C17.0495 24.2429 15.6977 25.0476 14.1666 25.3583V29.75C14.1666 30.5324 13.5324 31.1667 12.75 31.1667C11.9676 31.1667 11.3333 30.5324 11.3333 29.75V25.3583C8.10012 24.702 5.66663 21.8436 5.66663 18.4167V9.91671C5.66663 6.00469 8.83794 2.83337 12.75 2.83337C16.4456 2.83337 19.4802 5.66361 19.8046 9.27485C20.6445 8.78238 21.6226 8.50004 22.6666 8.50004C25.7962 8.50004 28.3333 11.0371 28.3333 14.1667V19.8334C28.3333 22.4738 26.5274 24.6925 24.0833 25.3215V29.75C24.0833 30.5324 23.449 31.1667 22.6666 31.1667C21.8842 31.1667 21.25 30.5324 21.25 29.75V25.3215C19.9392 24.9841 18.8119 24.1896 18.0484 23.1179ZM17 9.91671V18.4167C17 20.2672 15.8173 21.8414 14.1666 22.4249V18.4167C14.1666 17.6343 13.5324 17 12.75 17C11.9676 17 11.3333 17.6343 11.3333 18.4167V22.4249C9.6826 21.8414 8.49996 20.2672 8.49996 18.4167V9.91671C8.49996 7.5695 10.4027 5.66671 12.75 5.66671C15.0972 5.66671 17 7.5695 17 9.91671ZM24.0833 22.2877V18.4167C24.0833 17.6343 23.449 17 22.6666 17C21.8842 17 21.25 17.6343 21.25 18.4167V22.2877C20.4031 21.7978 19.8333 20.8821 19.8333 19.8334V14.1667C19.8333 12.6019 21.1018 11.3334 22.6666 11.3334C24.2314 11.3334 25.5 12.6019 25.5 14.1667V19.8334C25.5 20.8821 24.9302 21.7978 24.0833 22.2877Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees);
export default __webpack_public_path__ + "static/media/trees.b1e4e5013ba9432c7c8263c40cbdcd6a.svg";
export { ForwardRef as ReactComponent };